import * as React from 'react'
import { create } from 'zustand'
import MuiSnackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'

export const useSnackbar = create(set => ({
    snackbar: {
        snackbarOpen: false,
        snackbarType: 'success',
        snackbarMessage: '',
    },
    showSnackbar: (
        snackbarType,
        snackbarMessage,
        snackbarPosition,
        snackbarHide
    ) => {
        return set(state => ({
            snackbar: {
                snackbarOpen: true,
                snackbarType,
                snackbarMessage,
                snackbarPosition: snackbarPosition || 'bottom',
                snackbarHide: snackbarHide || 3000,
            },
        }))
    },
    hideSnackbar: () =>
        set(state => ({
            snackbar: { ...state.snackbar, snackbarOpen: false },
        })),
}))

const selectorSnackbar = state => state.snackbar
const selectorHideSnackbar = state => state.hideSnackbar

export default function Snackbar() {
    const {
        snackbarOpen,
        snackbarType,
        snackbarMessage,
        snackbarPosition,
        snackbarHide,
    } = useSnackbar(selectorSnackbar)
    const hideSnackbar = useSnackbar(selectorHideSnackbar)

    const presetPosition = snackbarPosition || 'bottom'
    const presetAutohide = snackbarHide || 3000

    const completePosition =
        presetPosition == 'top-right'
            ? { vertical: 'top', horizontal: 'right' }
            : { vertical: presetPosition, horizontal: 'center' }

    return (
        <MuiSnackbar
            anchorOrigin={completePosition}
            autoHideDuration={presetAutohide}
            onClose={(event, reason) => {
                // Ignore "clickaway" so a toast doesn't vanish when the user
                // interacts with the page during the long-running calculations
                if (reason === 'clickaway') return
                hideSnackbar()
            }}
            open={snackbarOpen}
            key={'vertical' + 'horizontal'}
            sx={{ mt: 4 }}
        >
            <Alert
                onClose={hideSnackbar}
                severity={snackbarType}
                sx={{ width: '100%', typography: 'subtitle1', zIndex: 1400 }}
            >
                <div dangerouslySetInnerHTML={{ __html: snackbarMessage }} />
            </Alert>
        </MuiSnackbar>
    )
}
